import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { PropertyDataResponse, LocationDataResponse, PropertyCodesResponse } from 'src/models/location-data.model';

@Component({
  selector: 'property-info-overlay',
  templateUrl: './property-info-overlay.component.html',
  styleUrls: ['./property-info-overlay.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyInfoOverlayComponent {
  @Input() propertyName = '';
  @Input() propertyData: PropertyDataResponse | null = null;
  @Input() locationData: LocationDataResponse | null = null;
  @Input() propertyCodesData: PropertyCodesResponse | null = null;
  @Input() isLoading = false;
  @Input() isExpanded = false;
  @Output() toggleExpand = new EventEmitter<void>();
  @Output() iconClicked = new EventEmitter<string>();

  onToggleExpand(): void {
    this.toggleExpand.emit();
  }

  onIconClick(iconType: string): void {
    this.iconClicked.emit(iconType);
  }

  getWeatherIcon(): string {
    const conditions = this.locationData?.attributes?.weather?.data?.conditions?.toLowerCase();
    if (!conditions) { return 'wb_sunny'; }
    if (conditions.includes('rain')) { return 'water_drop'; }
    if (conditions.includes('snow')) { return 'ac_unit'; }
    if (conditions.includes('cloud')) { return 'cloud'; }
    if (conditions.includes('fog') || conditions.includes('mist')) { return 'blur_on'; }
    if (conditions.includes('storm')) { return 'thunderstorm'; }
    return 'wb_sunny';
  }

  getWeatherLabel(): string {
    const weather = this.locationData?.attributes?.weather?.data;
    if (!weather) { return ''; }
    if (weather.temperature !== undefined) {
      return `${Math.round(weather.temperature)}°`;
    }
    return weather.conditions || '';
  }

  formatNumber(value: number | undefined): string {
    if (value === undefined) { return ''; }
    return value.toLocaleString();
  }

  hasOrdinancesData(): boolean {
    const data = this.propertyCodesData?.data;
    if (!data) { return false; }
    return !!(data.leaf_blower || data.water || data.business || data.str || data.property || data.parking);
  }
}
